<template>
    <button
        class="round-cta"
        role="button"
    >
        <img
            :src="`/img/ui/icon-${icon}.svg`"
            class="round-cta__icon"
        />
    </button>
</template>

<script>

export default {


    /* Settings
    --------------------------------------------------------- */

    name: 'RoundButton',

    components: {
    },

    props: {
        icon : { type: String, required: true },
    },

    data() {
        return {
            //
        }
    },


    /* Life Cycle
    --------------------------------------------------------- */

    created() {
        //
    },


    mounted() {
        //
    },


    /* Data Handling
    --------------------------------------------------------- */


    computed: {
        //
    },


    watch: {
        //
    },


    /* Methods
    --------------------------------------------------------- */

    methods: {

    },


    /* Handlers
    --------------------------------------------------------- */


}

</script>
